export const SWEETLINK_AUTO_KEY = 'sweetlink:auto';
export const SWEETLINK_AUTO_RESUME_FROM_KEY = 'sweetlink:auto:resumeFrom';
